import React, {useContext, useEffect, useRef, useState} from "react";
import {goVehisService} from "../../utils/axios";
import OwlCarousel from "react-owl-carousel";
import ConvertUtils from "../../utils/ConvertUtils";
import {CustomerTypeContext} from "../../context/customer-type-context";
import VehicleOfferListItem from "../../components/VehicleOfferListItem/VehicleOfferListItem";
import {Link, useHistory} from "react-router-dom";
import {useMediaQuery} from "react-responsive";

function SimilarOffers(props) {

    const MAX_SPECIAL_OFFERS_COUNT = 12;

    const [similarOffers, setSimilarOffers] = useState([]);
    const owlCarouselRef = useRef(null);
    const currentCustomerType = useContext(CustomerTypeContext)[0];
    const history = useHistory();
    const isMobile = useMediaQuery({maxWidth: 767});

    let vehicleOffer = props.offer;

    useEffect(() => {
        goVehisService.post("vehicles/similarofferswithoutduplicates?customerType=" + currentCustomerType,vehicleOffer)
            .then(response => setSimilarOffers(response.data.slice(0, MAX_SPECIAL_OFFERS_COUNT)))
    }, [currentCustomerType]);

    useEffect(() => {
        if (owlCarouselRef.current != null) {
            owlCarouselRef.current.forceUpdate();
        }
    }, [currentCustomerType]);

    if (similarOffers.length > 0) {
        let offers = similarOffers.map(offer => (
            <VehicleOfferListItem
                isSliderOffer={true}
                showRibbons={true}
                key={offer.id}
                url={"/" + ConvertUtils.stringToUrl(offer.brandName.replace("/", "") + "/" + offer.versionName + "/" + offer.id)}
                offer={offer}
                className="hot-offer"
            />
        ));

        return (
            <div id="hot-offers">
                <h3 className="center">Sprawdź podobne oferty</h3>
                <div id="similiar-offers-bg">


                    <div className="container">
                        <OwlCarousel
                            ref={owlCarouselRef}
                            id="hot-offers-slider"
                            loop={true}
                            margin={30}
                            nav={true}
                            dots={!isMobile}
                            mouseDrag={false}
                            lazyLoad={true}
                            navText={["<", ">"]}
                            responsive={{
                                0: {items: 1, margin: 0},
                                480: {items: 1},
                                768: {items: 2},
                                1024: {items: 3},
                                1199: {items: 4}
                            }}
                        >
                            {offers}

                        </OwlCarousel>

                    </div>
                    <Link to={{pathname: "/lista-ofert", search: "segments="+vehicleOffer.segment+"&bodyTypes="+vehicleOffer.bodyType}} className="btn" style={{marginBottom:"20px"}}>
                        Wszystkie podobne oferty</Link>
                </div>
            </div>
        );

    }

    return null;

}

export default SimilarOffers;